// Sign in with the OnlyCat account (Auth0), as admin does.
import { IonContent, IonPage } from "@ionic/react";
import { useState } from "react";
import { login } from "../auth/auth";
import { ErrorNote } from "../shell/ui";

export function SignInPage({ returnTo }: { returnTo?: string }) {
  const [error, setError] = useState<Error | null>(null);
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await login(returnTo ?? window.location.pathname); } catch (e) { setError(e as Error); setBusy(false); }
  };
  return (
    <IonPage>
      <IonContent>
        <div className="signin">
          <div className="card">
            <h1>Production planner</h1>
            <p>The team's week, the shelves and your bench. Sign in with your OnlyCat account.</p>
            <button type="button" className="btn btn--primary btn--lg" onClick={go} disabled={busy}>{busy ? "Opening sign-in…" : "Sign in"}</button>
            {import.meta.env.DEV ? (
              <p style={{ marginTop: "var(--space-4)", marginBottom: 0 }}>
                <a href="/week?fixture=1">Look around with this week's snapshot</a>
              </p>
            ) : null}
            <ErrorNote error={error} />
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
